var _a, _b, _c;
import { Brand } from '@lendi/core-constants';
import BaseJoi from 'joi';
import JoiPhoneNumber from 'joi-phone-number';
import { australianTimezones } from '../../data';
import { Origin } from '../../enums';
var Joi = BaseJoi.extend(JoiPhoneNumber);
export var joiMinimumLeadSchema = Joi.object({
    // Required Properties
    generatedAt: Joi.custom(function (value, helper) {
        /**
         * Custom validator because Joi.date().iso() mutates the value.
         *
         * We still use it for validation and return the original value if it passes.
         *
         * What Joi.date().iso() does:
         *
         * { generatedAt: "2011-10-05T14:48:00.000Z" }
         *
         * becomes:
         *
         * { generatedAt: 2011-10-05T14:48:00.000Z }
         *
         * which we don't want for consumers of the lead data.
         */
        var validator = Joi.date().iso().validate(value);
        var validatorErrorFound = 'error' in validator && (validator === null || validator === void 0 ? void 0 : validator.error);
        return validatorErrorFound ? helper.error(validator.error) : value;
    }),
    brand: (_a = Joi.string())
        .valid.apply(_a, Object.values(Brand)).required(),
    accountOrigin: Joi.string().required(),
    timeZone: (_b = Joi.string())
        .valid.apply(_b, australianTimezones).required(),
    origin: (_c = Joi.string())
        .valid.apply(_c, Object.values(Origin)).required(),
    mobileNumber: Joi.when('customerId', {
        is: Joi.string().required(),
        then: Joi.string().optional().allow(''),
        otherwise: Joi.string().phoneNumber({ region: 'AU', strict: true }).required(),
    }),
    // Optional Properties
    customerId: Joi.string().optional(),
    email: Joi.string()
        .email({ tlds: { allow: false } })
        .optional(),
    firstName: Joi.string().optional(),
    lastName: Joi.string().optional(),
    gclId: Joi.string().optional(),
    utm: Joi.object().optional(),
    data: Joi.object().optional(),
    ownerId: Joi.string().optional(),
    storeId: Joi.string().optional(),
    brokerStorePage: Joi.boolean().optional(),
});
export default joiMinimumLeadSchema;
//# sourceMappingURL=index.js.map